module.exports = __webpack_public_path__ + "static/3-8bee05f5df8de7262489dc7635bdcb27.png";